import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, Outlet } from "react-router-dom";
import clsx from "clsx";
import { removeUser } from "store/auth/authSlice";

const MainLayout = () => {
  const [isMenuActive, setIsMenuActive] = useState(false);

  const { role, picture, name } = useSelector((state) => state.auth);
  const dispatch = useDispatch();

  return (
    <>
      {/* Overlay */}
      <div
        className={clsx(
          "fixed inset-0 bg-black/40 backdrop-blur-sm z-40 transition-opacity",
          isMenuActive ? "opacity-100" : "opacity-0 pointer-events-none"
        )}
        onClick={() => setIsMenuActive(false)}
      ></div>

      {/* User Menu Dropdown */}
      <nav
        aria-label="Main navigation"
        className={clsx(
          "fixed z-50 left-0 top-[72px] sm:top-[80px] bg-white/95 backdrop-blur-xl shadow-2xl rounded-br-2xl rounded-tr-2xl transition-all duration-300 overflow-hidden border border-white/40",
          isMenuActive ? "translate-x-0 opacity-100" : "-translate-x-full opacity-0"
        )}
      >
        <div className="flex flex-col min-w-[260px]">
          <Link 
            to="/" 
            onClick={() => setIsMenuActive(false)}
            className="px-6 py-4 hover:bg-emerald-50 transition-colors text-slate-800 font-medium border-b border-slate-100 text-base"
          >
            Quiz
          </Link>
          {role === "admin" && (
            <>
              <Link 
                to="/add-question" 
                onClick={() => setIsMenuActive(false)}
                className="px-6 py-4 hover:bg-emerald-50 transition-colors text-slate-800 font-medium border-b border-slate-100 text-base"
              >
                Manage Questions
              </Link>
              <Link 
                to="/users-list" 
                onClick={() => setIsMenuActive(false)}
                className="px-6 py-4 hover:bg-emerald-50 transition-colors text-slate-800 font-medium border-b border-slate-100 text-base"
              >
                Users List
              </Link>
              <Link 
                to="/answers-report" 
                onClick={() => setIsMenuActive(false)}
                className="px-6 py-4 hover:bg-emerald-50 transition-colors text-slate-800 font-medium border-b border-slate-100 text-base"
              >
                Answers Report
              </Link>
            </>
          )}
          <button
            onClick={() => {
              dispatch(removeUser());
              setIsMenuActive(false);
            }}
            className="px-6 py-4 hover:bg-red-50 transition-colors text-red-600 font-medium text-left text-base"
          >
            Logout
          </button>
        </div>
      </nav>
      <header className="fixed z-50 left-0 right-0 top-0 bg-white/90 backdrop-blur-xl shadow-sm border-b border-white/40">
        <div className="flex justify-between items-center px-4 sm:px-6 py-2.5 sm:py-3">
          {/* Left Side - User Info & Menu */}
          <div 
            className="flex gap-2 sm:gap-3 items-center cursor-pointer hover:bg-emerald-50/60 rounded-xl p-1.5 sm:p-2 transition-colors"
            onClick={() => setIsMenuActive(!isMenuActive)}
            role="button"
            aria-expanded={isMenuActive}
            aria-haspopup="true"
            aria-label={`Open menu for ${name}`}
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setIsMenuActive(!isMenuActive)}
          >
            <div className="w-10 h-10 sm:w-11 sm:h-11 overflow-hidden rounded-full border-2 border-emerald-400 ring-2 ring-emerald-100">
              <img src={picture} alt={name} className="w-full h-full object-cover" />
            </div>
            <div className="hidden md:block">
              <h4 className="font-semibold text-slate-800 text-sm">{name}</h4>
              {role === "admin" && (
                <span className="text-xs text-emerald-600 font-medium">Admin</span>
              )}
            </div>
            <svg 
              className={clsx("w-4 h-4 sm:w-5 sm:h-5 text-slate-500 transition-transform", isMenuActive && "rotate-180")}
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              aria-hidden="true"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </div>

          {/* Right Side - UBAY Logo */}
          <Link to="/" aria-label="Go to Ubay home">
            <img 
              src="/assets/imgs/UbayNewLogo.png" 
              alt="Ubay – Daily Islamic Quizzes" 
              className="h-11 sm:h-14 md:h-16 w-auto object-contain"
            />
          </Link>
        </div>
      </header>
      
      <main className="pt-[72px] sm:pt-[80px]">
        <Outlet />
      </main>
    </>
  );
};

export default MainLayout;
